import { Spinner } from "../ui/spinner";

interface LoadingScreenProps {
  /** Unused; kept optional so existing consumers that pass it keep compiling. */
  title?: string;
}

export const LoadingScreen = (_props: LoadingScreenProps) => {
  return (
    <div className="flex min-h-screen">
      <div className="w-full flex flex-col items-center justify-center px-6">
        <Spinner size="lg" />
        <p className="mt-6 text-sm text-muted-foreground text-center">
          Please wait while we set things up...
        </p>
      </div>
    </div>
  );
};
